import { useMutation } from "@tanstack/react-query";
import { apiClient } from "~/services/api.service";
import { endpointsPublic } from "~/services/endpoint";

// Định nghĩa kiểu dữ liệu cho form
interface ContactForm {
  name: string;
  email: string;
  message: string;
  phone: string;
  subject: string;
}

export const useCreateContactMutation = () => {
  const { mutateAsync, isPending, error } = useMutation({
    mutationFn: (formData: ContactForm) => {
      return apiClient.post(endpointsPublic.create_contact, {data: formData});
    },
    onSuccess: () => { console.log('Gửi thành công!'); },
    onError: (error) => { console.error('Có lỗi:', error); },
  });

  return {
    createContact: mutateAsync,
    isLoading: isPending,
    error,
  };
};